module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e(), _vm._v("c\n    ")], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-nav', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "light"
    },
    on: {
      "click": _vm.previousBook
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n          ")], 1)], 1), _vm._v(" "), _c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v("Air Freight Execution (Export)")]), _vm._v(" "), _c('b-navbar-nav', {
    staticClass: "ml-auto"
  }, [(_vm.totalCountSB == _vm.airExecutionShipperArray.length && _vm.airExecutionShipperArray.length > 0) ? _c('b-button', {
    staticClass: "pull-right",
    attrs: {
      "variant": "success",
      "size": "sm"
    },
    on: {
      "click": _vm.proceedToTally
    }
  }, [_vm._v("Proceed To Invoice")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('banner-component', {
    attrs: {
      "allModuleIdBanner": _vm.airFreightModel.allModuleId ? _vm.airFreightModel.allModuleId : '',
      "jobSeriesBanner": _vm.airFreightModel.airFFExportSeries ? _vm.airFreightModel.airFFExportSeries : '',
      "bannerClientName": _vm.SBDetail.clientName ? _vm.SBDetail.clientName : '',
      "iconId": "fa fa-ship"
    }
  }), _vm._v(" "), _c('b-card', {
    staticClass: "formCard"
  }, [_c('b-card-text', [(_vm.packageDetails.length > 0) ? _c('div', {
    staticClass: "mt-2"
  }, [_c('div', [_c('h5', [_c('b-badge', [_vm._v("Package Details")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('table', {
    staticClass: "table table-bordered",
    attrs: {
      "id": "portLocationNew"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Sr.no")]), _vm._v(" "), _c('th', [_vm._v("Client Name")]), _vm._v(" "), _c('th', [_vm._v("No.of Package")]), _vm._v(" "), _c('th', [_vm._v("Package Length")]), _vm._v(" "), _c('th', [_vm._v("Package Width")]), _vm._v(" "), _c('th', [_vm._v("Package Height")]), _vm._v(" "), _c('th', [_vm._v("Unit")]), _vm._v(" "), _c('th', [_vm._v("Package Volume")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.packageDetails), function(item1, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.clientName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.noOfPackage))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.packageLength))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.packageWidth))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.packageHeight))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.packageUnit))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.packageVolume))])])
  }))])])]) : _vm._e(), _vm._v(" "), (_vm.airExecutionShipperArray.length > 0) ? _c('div', {
    staticClass: "mt-3"
  }, [_c('h5', [_c('b-badge', [_vm._v("Shipper Details")])], 1), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('table', {
    staticClass: "table table-bordered",
    attrs: {
      "id": "SBDetailr"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("SN.")]), _vm._v(" "), _c('th', [_vm._v("Shipper Name")]), _vm._v(" "), _c('th', [_vm._v("Airway Type")]), _vm._v(" "), _c('th', [_vm._v("Edit")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.airExecutionShipperArray), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.clientName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.typeAirway))]), _vm._v(" "), _c('td', [_c('b-button', {
      attrs: {
        "variant": "outline-info",
        "size": "sm"
      },
      on: {
        "click": function($event) {
          _vm.viewEditShipper(item)
        }
      }
    }, [_vm._v("Edit")])], 1)])
  }))])])]) : _vm._e(), _vm._v(" "), (_vm.shipperDetailArray.length > 0 || _vm.airExecutionShipperDetail.airShipperExecutionId != '') ? _c('div', [_c('b-card', {
    staticClass: "gutr",
    staticStyle: {
      "background": "whiteSmoke"
    }
  }, [_c('md-layout', {
    attrs: {
      "gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "45"
    }
  }, [(_vm.airExecutionShipperDetail.airShipperExecutionId == '') ? _c('label', [_vm._v("Shipper Name")]) : _vm._e(), _vm._v(" "), (_vm.airExecutionShipperDetail.airShipperExecutionId == '') ? _c('model-list-select', {
    attrs: {
      "option-value": "shipperFreightId",
      "option-text": "clientNameNew",
      "list": _vm.shipperDetailArray,
      "placeholder": "Select Shipper Name",
      "isDisabled": _vm.airFreightModel.airFFType == 'fclNormal' ? true : false
    },
    model: {
      value: (_vm.airExecutionShipperDetail.shipperFreightId),
      callback: function($$v) {
        _vm.$set(_vm.airExecutionShipperDetail, "shipperFreightId", $$v)
      },
      expression: "airExecutionShipperDetail.shipperFreightId"
    }
  }) : _c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Shipper Name")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "disabled": ""
    },
    model: {
      value: (_vm.airExecutionShipperDetail.consignorName),
      callback: function($$v) {
        _vm.$set(_vm.airExecutionShipperDetail, "consignorName", $$v)
      },
      expression: "airExecutionShipperDetail.consignorName"
    }
  })], 1), _vm._v(" "), (!_vm.airExecutionShipperDetail.shipperFreightId && _vm.airFreightModel.airFFType != 'fclNormal') ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.shipperIdError))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', [_vm._v("Cargo Receipt Date at " + _vm._s(_vm.airFreightModel.shipmentExecution == 'AirFreight' ? "Warehouse" : " Warehouse"))]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "id": "MAWBDate",
      "name": "MAWBDate"
    },
    model: {
      value: (_vm.airExecutionShipperDetail.cargoReceipt),
      callback: function($$v) {
        _vm.$set(_vm.airExecutionShipperDetail, "cargoReceipt", $$v)
      },
      expression: "airExecutionShipperDetail.cargoReceipt"
    }
  }), _vm._v(" "), (!_vm.airExecutionShipperDetail.cargoReceipt) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorAirExecutionShipperDetail.cargoReceipt))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.airFreightModel.shipmentExecution == 'AirFreight' ? "Carting" : " Carting") + " Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "id": "MAWBDate",
      "name": "MAWBDate"
    },
    model: {
      value: (_vm.airExecutionShipperDetail.cargoDate),
      callback: function($$v) {
        _vm.$set(_vm.airExecutionShipperDetail, "cargoDate", $$v)
      },
      expression: "airExecutionShipperDetail.cargoDate"
    }
  }), _vm._v(" "), (!_vm.airExecutionShipperDetail.cargoDate) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorAirExecutionShipperDetail.cargoDate))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "45"
    }
  }, [_c('label', [_vm._v("Type of Airway")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "option-value": "value",
      "option-text": "text",
      "list": _vm.AirwayType,
      "placeholder": "Select B/L"
    },
    model: {
      value: (_vm.airExecutionShipperDetail.typeAirway),
      callback: function($$v) {
        _vm.$set(_vm.airExecutionShipperDetail, "typeAirway", $$v)
      },
      expression: "airExecutionShipperDetail.typeAirway"
    }
  }), _vm._v(" "), (!_vm.airExecutionShipperDetail.typeAirway) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorAirExecutionShipperDetail.typeAirway))]) : _vm._e()], 1), _vm._v(" "), (_vm.airExecutionShipperDetail.typeAirway == 'HouseAirwayBL') ? _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.airExecutionShipperDetail.typeAirway == 'HouseAirwayBL') ? _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', [_vm._v("Freight Terms For HAWB")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "option-value": "value",
      "option-text": "text",
      "list": _vm.freightTerms,
      "placeholder": "Select Terms"
    },
    model: {
      value: (_vm.airExecutionShipperDetail.HAWBTerms),
      callback: function($$v) {
        _vm.$set(_vm.airExecutionShipperDetail, "HAWBTerms", $$v)
      },
      expression: "airExecutionShipperDetail.HAWBTerms"
    }
  }), _vm._v(" "), (!_vm.airExecutionShipperDetail.HAWBTerms) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorAirExecutionShipperDetail.HAWBTerms))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.airExecutionShipperDetail.typeAirway == 'HouseAirwayBL') ? _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.airExecutionShipperDetail.typeAirway == 'HouseAirwayBL') ? _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('label', [_vm._v("Freight Terms For MAWB")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "option-value": "value",
      "option-text": "text",
      "list": _vm.freightTerms,
      "placeholder": "Select Terms"
    },
    model: {
      value: (_vm.airExecutionShipperDetail.MAWBTerms),
      callback: function($$v) {
        _vm.$set(_vm.airExecutionShipperDetail, "MAWBTerms", $$v)
      },
      expression: "airExecutionShipperDetail.MAWBTerms"
    }
  }), _vm._v(" "), (!_vm.airExecutionShipperDetail.MAWBTerms) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorAirExecutionShipperDetail.MAWBTerms))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), (_vm.airExecutionShipperDetail.typeAirway == 'DirectAirwayBL') ? _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', [_vm._v("Freight Terms")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "option-value": "value",
      "option-text": "text",
      "list": _vm.freightTerms,
      "placeholder": "Select Terms"
    },
    model: {
      value: (_vm.airExecutionShipperDetail.freightTerms),
      callback: function($$v) {
        _vm.$set(_vm.airExecutionShipperDetail, "freightTerms", $$v)
      },
      expression: "airExecutionShipperDetail.freightTerms"
    }
  }), _vm._v(" "), (!_vm.airExecutionShipperDetail.freightTerms) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorAirExecutionShipperDetail.freightTerms))]) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "45"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Consignor Name")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "name": "consignorName",
      "id": "consignorName"
    },
    model: {
      value: (_vm.airExecutionShipperDetail.consignorName),
      callback: function($$v) {
        _vm.$set(_vm.airExecutionShipperDetail, "consignorName", $$v)
      },
      expression: "airExecutionShipperDetail.consignorName"
    }
  })], 1), _vm._v(" "), (!_vm.airExecutionShipperDetail.consignorName) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorAirExecutionShipperDetail.consignorName))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "50"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Consignee (Order)")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "name": "HAWBNumber",
      "id": "HAWBNumber"
    },
    model: {
      value: (_vm.airExecutionShipperDetail.consigneeOrder),
      callback: function($$v) {
        _vm.$set(_vm.airExecutionShipperDetail, "consigneeOrder", $$v)
      },
      expression: "airExecutionShipperDetail.consigneeOrder"
    }
  })], 1), _vm._v(" "), (!_vm.airExecutionShipperDetail.consigneeOrder) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorAirExecutionShipperDetail.consigneeOrder))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "45"
    }
  }, [_c('label', [_vm._v("Delivery Agent")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "option-value": "agntColoaderId",
      "option-text": "agentName",
      "list": _vm.agentMasterList,
      "placeholder": "Select Agent"
    },
    model: {
      value: (_vm.airExecutionShipperDetail.delieveryAgent),
      callback: function($$v) {
        _vm.$set(_vm.airExecutionShipperDetail, "delieveryAgent", $$v)
      },
      expression: "airExecutionShipperDetail.delieveryAgent"
    }
  }), _vm._v(" "), (!_vm.airExecutionShipperDetail.delieveryAgent) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorAirExecutionShipperDetail.delieveryAgent))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "gutter": ""
    }
  }, _vm._l((_vm.airExecutionShipperDetail.notifyList), function(singleInput, index) {
    return _c('md-layout', {
      key: index,
      attrs: {
        "md-flex": "100"
      }
    }, [_c('md-layout', {
      attrs: {
        "md-flex": "100"
      }
    }, [_c('md-layout', {
      attrs: {
        "md-flex": "95"
      }
    }, [_c('label', [_vm._v(_vm._s(_vm.notifyArray[index]) + " Notify Party")])]), _vm._v(" "), (index > 1) ? _c('md-layout', {
      staticClass: "gutr",
      attrs: {
        "md-flex": "5"
      }
    }, [_c('md-button', {
      staticClass: "md-icon-button md-raised md-dense",
      staticStyle: {
        "min-height": "20px",
        "height": "20px"
      },
      on: {
        "click": function($event) {
          _vm.removeNotify(index)
        }
      }
    }, [_c('md-icon', [_vm._v("close")])], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
      attrs: {
        "md-flex": "100"
      }
    }, [_c('md-layout', {
      attrs: {
        "md-flex": "100"
      }
    }, [_c('b-form-textarea', {
      attrs: {
        "formatter": _vm.capitalizeAll,
        "id": "inputValue",
        "name": "inputValue"
      },
      model: {
        value: (singleInput.inputValue),
        callback: function($$v) {
          _vm.$set(singleInput, "inputValue", $$v)
        },
        expression: "singleInput.inputValue"
      }
    })], 1)], 1)], 1)
  })), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "outline-info",
      "size": "sm"
    },
    on: {
      "click": _vm.addNotify
    }
  }, [_vm._v("Add More Notify")])], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "10"
    }
  }, [_c('b-button', {
    staticClass: "smbutnWidth mt-3",
    attrs: {
      "size": "sm",
      "variant": "info",
      "id": "addButtonLoader1"
    },
    on: {
      "click": function($event) {
        _vm.addExecution('all')
      }
    }
  }, [_vm._v(_vm._s(_vm.airExecutionShipperDetail.airShipperExecutionId == '' ? 'Save' : 'Save'))]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loader1"
    }
  })], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.sbDetailArrayNew.length > 0) ? _c('div', {
    staticClass: "mt-3"
  }, [_c('h5', [_c('b-badge', [_vm._v(" Shipping Bill Details")])], 1), _vm._v(" "), (_vm.totalCountSB == _vm.airExecutionShipperArray.length && _vm.SBDetail.airSBDetailId == '') ? _c('b-button', {
    staticClass: "mt-2",
    attrs: {
      "variant": "outline-dark",
      "size": "sm"
    },
    on: {
      "click": _vm.showMoreSBDet
    }
  }, [_vm._v("Click here to " + _vm._s(_vm.showMoreSB == true ? "Hide" : "Add More") + " S/B Details")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_c('table', {
    staticClass: "table table-bordered",
    attrs: {
      "id": "SBDetailr"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("SN.")]), _vm._v(" "), _c('th', [_vm._v("Client Name")]), _vm._v(" "), _c('th', [_vm._v("Shipping Bill No")]), _vm._v(" "), _c('th', [_vm._v("Cargo Gross Weight")]), _vm._v(" "), _c('th', [_vm._v("Action")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.sbDetailArrayNew), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.clientName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.shippingBillNo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.cargoGrossWeight))]), _vm._v(" "), _c('td', [_c('b-button', {
      attrs: {
        "variant": "outline-info",
        "size": "sm"
      },
      on: {
        "click": function($event) {
          _vm.viewEditSB(item)
        }
      }
    }, [_vm._v("Edit")]), _vm._v(" "), _c('b-button', {
      attrs: {
        "variant": "outline-danger",
        "size": "sm"
      },
      on: {
        "click": function($event) {
          _vm.removeCommon(item, index, 'SB')
        }
      }
    }, [_vm._v("Delete")])], 1)])
  }))])])], 1) : _vm._e(), _vm._v(" "), (_vm.shipperDetailArray.length == 0) ? _c('div', [(_vm.totalCountSB != _vm.airExecutionShipperArray.length || _vm.showMoreSB == true || _vm.SBDetail.airSBDetailId != '') ? _c('div', [_c('b-card', {
    staticClass: "gutr",
    staticStyle: {
      "background": "whiteSmoke"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "95"
    }
  }, [_c('label', {
    staticStyle: {
      "margin": "0px"
    }
  }, [_c('h5', [_c('b-badge', [_vm._v(" Shipping Bill Details")])], 1), _vm._v(" "), (_vm.sbDetailArrayList.length == 0) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorAtleastSb))]) : _vm._e()])])], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "45"
    }
  }, [(_vm.SBDetail.airSBDetailId == '') ? _c('label', [_vm._v("Shipper Name")]) : _vm._e(), _vm._v(" "), (_vm.SBDetail.airSBDetailId == '') ? _c('model-list-select', {
    attrs: {
      "option-value": "airShipperExecutionId",
      "option-text": "clientName",
      "list": _vm.airExecutionShipperArray,
      "placeholder": "Select Shipper Name"
    },
    model: {
      value: (_vm.SBDetail.airShipperExecutionId),
      callback: function($$v) {
        _vm.$set(_vm.SBDetail, "airShipperExecutionId", $$v)
      },
      expression: "SBDetail.airShipperExecutionId"
    }
  }) : _c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Shipper Name")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "disabled": ""
    },
    model: {
      value: (_vm.SBDetail.clientName),
      callback: function($$v) {
        _vm.$set(_vm.SBDetail, "clientName", $$v)
      },
      expression: "SBDetail.clientName"
    }
  })], 1), _vm._v(" "), (!_vm.SBDetail.airShipperExecutionId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorSBExecution.airShipperExecutionId))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('label', [_vm._v("Invoice Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "name": "invoiceDate",
      "id": "invoiceDate",
      "minute-step": 1
    },
    model: {
      value: (_vm.SBDetail.invoiceDate),
      callback: function($$v) {
        _vm.$set(_vm.SBDetail, "invoiceDate", $$v)
      },
      expression: "SBDetail.invoiceDate"
    }
  }), _vm._v(" "), (!_vm.SBDetail.invoiceDate) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorSBExecution.invoiceDate))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Invoice No.")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "name": "invoiceNo",
      "id": "invoiceNo"
    },
    model: {
      value: (_vm.SBDetail.invoiceNo),
      callback: function($$v) {
        _vm.$set(_vm.SBDetail, "invoiceNo", $$v)
      },
      expression: "SBDetail.invoiceNo"
    }
  })], 1), _vm._v(" "), (!_vm.SBDetail.invoiceNo) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorSBExecution.invoiceNo))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('label', [_vm._v("Shipping Bill Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "name": "shippingBillDate",
      "id": "shippingBillDate",
      "minute-step": 1
    },
    model: {
      value: (_vm.SBDetail.shippingBillDate),
      callback: function($$v) {
        _vm.$set(_vm.SBDetail, "shippingBillDate", $$v)
      },
      expression: "SBDetail.shippingBillDate"
    }
  }), _vm._v(" "), (_vm.shippingBillDate_err ? true : false) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                      " + _vm._s(_vm.shippingBillDate_err) + "\n                    ")]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Shipping Bill No.")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "name": "shippingBillNo",
      "id": "shippingBillNo"
    },
    model: {
      value: (_vm.SBDetail.shippingBillNo),
      callback: function($$v) {
        _vm.$set(_vm.SBDetail, "shippingBillNo", $$v)
      },
      expression: "SBDetail.shippingBillNo"
    }
  })], 1), _vm._v(" "), (_vm.shippingBillNo_err ? true : false) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                      " + _vm._s(_vm.shippingBillNo_err) + "\n                    ")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Cargo Gross Weight")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "name": "cargoGrossWeight",
      "id": "cargoGrossWeight"
    },
    model: {
      value: (_vm.SBDetail.cargoGrossWeight),
      callback: function($$v) {
        _vm.$set(_vm.SBDetail, "cargoGrossWeight", $$v)
      },
      expression: "SBDetail.cargoGrossWeight"
    }
  })], 1), _vm._v(" "), (!_vm.SBDetail.cargoGrossWeight) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorSBExecution.cargoGrossWeight))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Cargo Net Weight")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "name": "cargoNetWeight",
      "id": "cargoNetWeight"
    },
    model: {
      value: (_vm.SBDetail.cargoNetWeight),
      callback: function($$v) {
        _vm.$set(_vm.SBDetail, "cargoNetWeight", $$v)
      },
      expression: "SBDetail.cargoNetWeight"
    }
  })], 1), _vm._v(" "), (!_vm.SBDetail.cargoNetWeight) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorSBExecution.cargoNetWeight))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('label', [_vm._v("Clearance Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "name": "clearanceDate",
      "id": "clearanceDate",
      "minute-step": 1
    },
    model: {
      value: (_vm.SBDetail.clearanceDate),
      callback: function($$v) {
        _vm.$set(_vm.SBDetail, "clearanceDate", $$v)
      },
      expression: "SBDetail.clearanceDate"
    }
  }), _vm._v(" "), (!_vm.SBDetail.clearanceDate) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorSBExecution.clearanceDate))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    staticStyle: {
      "margin-top": "35px"
    },
    attrs: {
      "md-flex": "10"
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "info",
      "size": "sm",
      "id": "addButtonLoaderSB"
    },
    on: {
      "click": _vm.addSBDetail
    }
  }, [_vm._v(_vm._s(_vm.SBDetail.airSBDetailId == '' ? "Add SB" : "Update"))]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loaderSB"
    }
  })], 1)], 1)], 1)], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.totalCountSB == _vm.airExecutionShipperArray.length && _vm.airExecutionShipperArray.length > 0) ? _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', [_vm._v("Handover Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "name": "clearanceDate",
      "id": "clearanceDate",
      "minute-step": 1
    },
    model: {
      value: (_vm.airExecutionModel.handoverDate),
      callback: function($$v) {
        _vm.$set(_vm.airExecutionModel, "handoverDate", $$v)
      },
      expression: "airExecutionModel.handoverDate"
    }
  }), _vm._v(" "), (!_vm.airExecutionModel.handoverDate) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.handoverDateError))]) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.totalCountSB == _vm.airExecutionShipperArray.length && _vm.airExecutionShipperArray.length > 0) ? _c('div', {
    staticClass: "mt-3"
  }, [_c('b-button', {
    attrs: {
      "variant": "warning",
      "size": "sm"
    },
    on: {
      "click": function($event) {
        _vm.uploadDocument()
      }
    }
  }, [_vm._v("Upload Document")]), _c('br'), _vm._v(" "), _c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "variant": "primary",
      "id": "addButtonLoader1"
    },
    on: {
      "click": function($event) {
        _vm.addExecution('fdsfdsf')
      }
    }
  }, [_vm._v("Save & Proced to Cargo Tracking")]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loader1"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.airExecutionModel.airFFType == 'fclConsolidation' && _vm.totalCountSB == _vm.airExecutionShipperArray.length && _vm.airExecutionShipperArray.length > 0) ? _c('div', [_c('b-button', {
    attrs: {
      "variant": "primary",
      "id": "addButtonLoader1"
    },
    on: {
      "click": function($event) {
        _vm.consolMaster()
      }
    }
  }, [_vm._v("Consol Master Merge")]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loader1"
    }
  })], 1) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPop6",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onClose6
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPop7",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onClose7
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPop",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPop2",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onCloseForward
    }
  }), _vm._v(" "), _c('div', [_c('b-modal', {
    ref: "DocPop",
    attrs: {
      "size": "xl",
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "scrollable": "",
      "id": "myDIV",
      "hide-footer": ""
    }
  }, [_c('div', {
    staticClass: "d-block text-center"
  }, [_c('b-card', {
    staticStyle: {
      "min-height": "500px !important"
    }
  }, [_c('b-card-text', [_c('b-button', {
    staticClass: "pull-right",
    attrs: {
      "size": "sm",
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.closeDialog
    }
  }, [_vm._v("Cancel & Close")]), _vm._v(" "), _c('div', [_c('md-layout', {
    staticClass: "gutr mt-4",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "35"
    }
  }, [_c('label', [_vm._v("Document Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "option-value": "uploadVal",
      "option-text": "uploadText",
      "list": _vm.uploadDocumentList,
      "placeholder": "Select Document Type"
    },
    model: {
      value: (_vm.DocumentList.documentType),
      callback: function($$v) {
        _vm.$set(_vm.DocumentList, "documentType", $$v)
      },
      expression: "DocumentList.documentType"
    }
  }), _vm._v(" "), (!_vm.DocumentList.documentType) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorDocumentList.documentType))]) : _vm._e(), _vm._v(" "), (!_vm.airExecutionShipperDetail.delieveryAgent) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorAirExecutionShipperDetail.delieveryAgent))]) : _vm._e()], 1), _vm._v(" "), (_vm.DocumentList.documentType == 'Others') ? _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.DocumentList.documentType == 'Others') ? _c('md-layout', {
    attrs: {
      "md-flex": "35"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Document Name")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "name": "cargoNetWeight",
      "id": "cargoNetWeight"
    },
    model: {
      value: (_vm.DocumentList.docName),
      callback: function($$v) {
        _vm.$set(_vm.DocumentList, "docName", $$v)
      },
      expression: "DocumentList.docName"
    }
  })], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr mt-4",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-input-container', [_c('label', [_vm._v("Upload Document")]), _vm._v(" "), _c('md-file', {
    attrs: {
      "name": "uploadDocument",
      "id": "uploadDocument",
      "multiple": ""
    },
    on: {
      "selected": _vm.onFileChangeCargo
    },
    model: {
      value: (_vm.DocumentList.uploadDocumentType),
      callback: function($$v) {
        _vm.$set(_vm.DocumentList, "uploadDocumentType", $$v)
      },
      expression: "DocumentList.uploadDocumentType"
    }
  })], 1), _vm._v(" "), (!_vm.DocumentList.uploadDocumentType) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorDocumentList.uploadDocumentType))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    staticStyle: {
      "margin-top": "38px"
    },
    attrs: {
      "md-flex": "10"
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "info",
      "size": "sm",
      "id": "addButtonLoader3"
    },
    on: {
      "click": function($event) {
        _vm.submitDoument()
      }
    }
  }, [_vm._v("Upload")]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loader3"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body",
    staticStyle: {
      "margin-top": "5%"
    }
  }, [_c('table', {
    staticClass: "table table-bordered",
    attrs: {
      "id": "truckDetail"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("SN.")]), _vm._v(" "), _c('th', [_vm._v("Document Type")]), _vm._v(" "), _c('th', [_vm._v("Uploaded Document")]), _vm._v(" "), _c('th', [_vm._v("Delete ")])])]), _vm._v(" "), _c('tbody', [(_vm.documentArrayList.length == 0) ? _c('tr', [_c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v("No Document Type")]), _vm._v(" "), _c('td', [_vm._v("No Document Uploaded")]), _vm._v(" "), _c('td', [_vm._v("-")])]) : _vm._l((_vm.documentArrayList), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.documentType))]), _vm._v(" "), _c('td', _vm._l((item.uploadDocumentType), function(itemDate, index) {
      return _c('span', {
        key: index,
        staticClass: "showMoreData",
        on: {
          "click": function($event) {
            _vm.showPrint(itemDate)
          }
        }
      }, [_vm._v(_vm._s(itemDate) + " " + _vm._s(index != Object.keys(item.uploadDocumentType).length - 1 ? " , " : ""))])
    })), _vm._v(" "), _c('td', [_c('md-button', {
      staticClass: "md-icon-button md-raised md-dense",
      on: {
        "click": function($event) {
          _vm.removeCommon(item, index, 'Doc')
        }
      }
    }, [_c('md-icon', [_vm._v("delete_sweep")])], 1)], 1)])
  })], 2)])])])], 1)], 1)], 1)], 1)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d6312ffa","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/airFreight/AirFreightExecution.vue
// module id = 2872
// module chunks = 0